module.exports = __webpack_public_path__ + "static/img/02_partner.058de56.png";